/*hg-treck-res*/
		$isResizeble = false;
		$new_mhs = false;
/*hg-treck-res*/
/*hg-norm-adpt*/

$('.ll-video').each(function(index) {
	$pc_v = $(this).attr('data-v-pc');
	$m_v = $(this).attr('data-v-m');
	if ($(window).width() > 1023) {
				$(this).find('source').attr('src', $pc_v);
				$(this).trigger('load');
				$(this).trigger('play');
			
		}else{
				$(this).find('source').attr('src', $m_v);
				$(this).trigger('load');
				$(this).trigger('play');
	}
});	


	$(window).on('load resize', function(){
	  if ($(window).width() > 1040) {
	/*ll-hg-pc bg*/
	        $(window).scroll(function(e){
	          var scroll = $(window).scrollTop();
	          $wh = $(window).height();
	          
	         $('.hg-ll-img').each(function() {
	          $lod_i = $(this).attr('data-p-i');
	        $cprod_t = $(this).offset().top/ 2;
	        if(scroll + $wh > $cprod_t){
	          if ($(this).is('[style="background-image"]')){ }else {
	          $(this).css('background-image','url('+$lod_i+')');
	          }
	        }
	        });
	      });

	       $(window).scroll(function(e){
	          var scroll_i = $(window).scrollTop();
	          $wh_i = $(window).height();
	          
	         $('.imgll-hg').each(function() {
	        $lod_ii = $(this).attr('data-src-pc');
	        $cprod_ti = $(this).offset().top;
	        if(scroll_i + $wh_i > $cprod_ti){
	          if ($(this).is('[src]')){ }else {
	          $(this).attr('src',$lod_ii);
	          }
	        }
	        });
	      }); 
	/*ll-hg-pc bg*/
	/*hov-prod*/
	$(".hg-prod").hover(function () {
	    var sourceFile = $(this).find(".prod_bg_img_h").attr("data_h");
	    if ($(this).find(".prod_bg_img_h").is('[style="background-image"]')) {
	    }else{
	    $(this).find(".prod_bg_img_h").css('background-image', 'url('+sourceFile+')');  
	    };
	    }, function () {
	 });
	/*hov-prod*/
	   } else {
	/*ll-hg-mob bg*/
	$rou_wh_w = $(window).height();
	$rou_wh_s = screen.availHeight;
	$rou_wh_n = ($rou_wh_s  - $rou_wh_w) /3;
	$rou_wh = $rou_wh_s - $rou_wh_n;
	$('head').append('<style>html body:after,html body:before{height:'+$rou_wh+'px}</style>');


	       $(window).scroll(function(e){
	          var scroll_i = $(window).scrollTop();
	          $wh_i = $(window).height();
	          
	         $('.imgll-hg').each(function() {
	        $lod_ii = $(this).attr('data-src-m');
	        $cprod_ti = $(this).offset().top;
	        if(scroll_i + $wh_i > $cprod_ti){
	          if ($(this).is('[src]')){ }else {
	          $(this).attr('src',$lod_ii);
	          }
	        }
	        });
	      }); 
	
	        $(window).scroll(function(e){
	          var scroll = $(window).scrollTop();
	          $wh = $(window).height();
	          
	          $('.hg-ll-img').each(function() {
	    
	        $cprod_t = $(this).offset().top;
	        if(scroll + $wh > $cprod_t){
	        if ($(window).width() > 1040) {
	          	$lod_i = $(this).attr('data-p-i');
	      	}else{
	      	  	$lod_i = $(this).attr('data-m-i');
	      	}


	          if ($(this).is('[style="background-image"]')){ }else {
	          $(this).css('background-image','url('+$lod_i+')');
	          }
	        }
	        });
	      });
	/*ll-hg-mob bg*/
		if(!$isResizeble) {
		}
	}
	});
/*hg-norm-adpt*/
$( document ).ready(function() {

	        $('.hg-ll-img-st').each(function() {
	          if ($(window).width() > 1040) {
	          	$lod_i = $(this).attr('data-p-i');
	      	  }else{
	      	  	$lod_i = $(this).attr('data-m-i');
	      	  }
	          if ($(this).is('[style="background-image"]')){ }else {
	          $(this).css('background-image','url('+$lod_i+')');
	          }
	        });
	       	$('.hg-ll-img-st-sl').each(function() {
	          if ($(window).width() > 1040) {
	          	$lod_i = $(this).attr('data-p-i');
	      	  }else{
	      	  	$lod_i = $(this).attr('data-p-i');
	      	  }
	          if ($(this).attr('data-flickity-bg-lazyload') == ''){ 
	          $(this).attr('data-flickity-bg-lazyload',$lod_i);
	          }
	        });
	
		 /*setTimeout("$('body').addClass('page-ready')", 600);
	     setTimeout("$(window).trigger('scroll')", 300);
	       $(window).scroll(function(e){
	       	var scroll_h = $(window).scrollTop();
	       	if (scroll_h  > 100) {
	       		$('header').addClass('h-logo');
	       	}else{
	       		$('header').removeClass('h-logo');
	       	}

	       	  });


	/*hg-fl
		$mcitem_h = $('.woocommerce-mini-cart-item.mini_cart_item:first-child').height();
		$('#in-m-cart .product_list_widget').css('height', $mcitem_h );
		  setTimeout(function(){$('body').addClass('page-load');}, 300);
		  cur_t_val = $('#in-m-cart .woocommerce-mini-cart__total bdi').text();
		  $('.in-h-c-total .woocommerce-Price-amount bdi').text(cur_t_val);
		  $c_home_l = $('.home-slide-l').flickity({
		  	 cellAlign: "left",
		  	 prevNextButtons: false,
		  	 adaptiveHeight: true,
		  	 resize : true,  
		  	 contain: true,
		  	 pageDots: false, 
		  	 bgLazyLoad: true, 
		  	 bgLazyLoad: 1
		  });
		  $c_home_r = $('.home-slide-r').flickity({
		  	 cellAlign: "left",
		  	 prevNextButtons: false,
		  	 adaptiveHeight: true,
		  	 resize : true,  
		  	 contain: true,
		  	 pageDots: false, 
		  	 bgLazyLoad: true, 
		  	 bgLazyLoad: 1
		  });

		$carousel_pg = $('.gall-slider');
		  $('#nav-prod-gall .next-pg').on( 'click', function() {
		       $carousel_pg.flickity('next');
		  });
		$('#nav-prod-gall .prev-pg').on( 'click', function() {
			       $carousel_pg.flickity('previous');
		  });
	/*hg-fl-nav*/
	/*hg-cl-nav*/
		/*m-cart*/
		 $('.r-btn').click(function() {
			    $('body').addClass('prod-form');
		  });
		 $('#close-form').click(function() {
			    $('body').removeClass('prod-form');
		  });
		/*m-cart*/
	  	/*m-menu*/
		  $('#mob-menu').click(function() {
		  if (!$(this).hasClass('close-m')) { 
		    $(this).addClass('close-m');
		    $('body').addClass('m-menu-open');
		  } else { 
		    $(this).removeClass('close-m');
		    $('body').removeClass('m-menu-open');
		  }
		  });
		  $('#colose-mc').click(function() {
		  	$('body').removeClass('mc-in-open');
			$(this).removeClass('btn-rot');
		  });
	  	/*m-menu*/
  	/*hg-cl-nav*/
  	/*scroll-f
	   	$(window).scroll(function(e){
			var scroll = $(window).scrollTop();
			$wh = $(window).height();
			    
			$hh = $('header').height();
			    if(scroll >  $hh ) {$('header').addClass('scroll-header');} 
			    else {$('header').removeClass('scroll-header');}

		});
   	scroll-f*/
  	/*fadeinup*/
//tabs
$('li.tan-l').click(function() {
	if ($(this).hasClass('active')) { }else{
		$(this).addClass('active');
		$(this).nextAll().removeClass('active');
		$(this).prevAll().removeClass('active');
		$a_tab = $(this).attr('data-t');
		$('div[data-ct="'+$a_tab+'"]').addClass('active');
		$('div[data-ct="'+$a_tab+'"]').nextAll().removeClass('active');
		$('div[data-ct="'+$a_tab+'"]').prevAll().removeClass('active');

	}
});




	  	var doAnimations = function() {
	    var offset = $(window).scrollTop() + $(window).height(),
	        $animatables = $('.animatable');
	    if ($animatables.length == 0) {
	      $(window).off('scroll', doAnimations);
	    }
	    
	    $animatables.each(function(i) {
	       var $animatable = $(this);
	         if ($(window).width() < 960) {
	          var $scrollstep = 150;
	         }else{
	          var $scrollstep = 200;
	         };
	      if (($animatable.offset().top  + $scrollstep) < offset) {
	        $animatable.removeClass('animatable').addClass('animated');
	      }
	    });
	  };
	  $(window).on('scroll', doAnimations);
	  $(window).trigger('scroll');
  /*fadeinup*/
  /*step by step*
	lptch = 0;
	$('#in-logo svg .logo-i-f').each(function() {
		lptch++;
		tlp = 100 * lptch;
     setTimeout("$('#in-logo svg .logo-i-f:nth-child("+lptch+")').addClass('fadeInUppre')", tlp);
	});
  step by step*/
});


